import { useState } from 'react';
import { getCurrentUser } from '../AppShell/Authentication/AuthorisationAsync';
import { UserIUser } from '../AppShell/Authentication/AuthorisationModels';
import { Nullable } from '../Shared/Types';

export let globalIdentifyUser: Nullable<UserIUser> = null;

export let getIdentityUser = (): Nullable<UserIUser> => {
    if (globalIdentifyUser) {
        return globalIdentifyUser;
    } else {
        console.error('Identity user was requested when no user is stored');
        return null;
    }
};

export let refreshIdentityUser = async () => {
    globalIdentifyUser = await getCurrentUser();
};

export enum IdentityLoadingStatus {
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error'
}

export function useIdentityLoader() {
    const [identityStatus, setIdentityStatus] = useState<IdentityLoadingStatus>(IdentityLoadingStatus.Loading);

    async function loadUser() {
        try {
            globalIdentifyUser = await getCurrentUser();
            setIdentityStatus(IdentityLoadingStatus.Loaded);
        } catch (err) {
            console.error('Error loading user: ', err);
            setIdentityStatus(IdentityLoadingStatus.Error);
        }
    }

    return {
        identityStatus,
        loadUser
    };
}
